import { HttpInterceptorFn } from '@angular/common/http';

export const langInterceptor: HttpInterceptorFn = (req, next) => {
  // Skip for image/binary requests
  if (req.headers.has('Skip-Interceptor') || req.responseType === 'blob' || req.responseType === 'arraybuffer') {
    return next(req);
  }

  const lang = localStorage.getItem('langBtakkaBus') || localStorage.getItem('lang') || 'ar';
  
  const cloned = req.clone({
    setParams: {
      lang: lang
    }
  });

  return next(cloned);
};
